import styled, { css } from "styled-components";

export const ItemTitle = styled.p`
  font-size: var(--textM);
  font-weight: normal;
  line-height: var(--lineHeightL);
  padding: 0px;
  margin: 0px;
  width: 100%;
  overflow: hidden;
  display: block;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  @media screen and (min-width: 1128px) {
    font-size: var(--textM);
    line-height: var(--lineHeightM);
    display: -webkit-box;
  }
`;

export const ItemListWrapper = styled.li`
  width: 100%;
  min-height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacingS) var(--spacingM);
  list-style: none;
  gap: var(--spacingM);
`;

export const AccordionItemWrapper = styled.div`
  cursor: pointer;
  &:not(:last-of-type) {
    border-bottom: 1px solid var(--gray200);
  }

  > p {
    display: none;
    font-size: var(--textM);
    padding: 0px var(--spacingM);
    color: var(--gray700);
    white-space: break-spaces;
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      > p {
        display: block;
      }
    `}

  @media screen and (min-width: 1128px) {
    border-bottom: 1px solid var(--gray200);

    &:first-of-type {
      border-top: 1px solid var(--gray200);
    }
  }
`;

export default ItemListWrapper;
